document.addEventListener("DOMContentLoaded", () => {
  let wishlist =
    JSON.parse(localStorage.getItem("build-a-bear__wishlist")) || [];

  const customerDataElement = document.getElementById("customer-data");
  const productDataElement = document.getElementById("product-data");
  const loadingMessage = document.getElementById("wishlist-loading");

  // const wishlistIcons = document.querySelectorAll(`[id^="wishlist-icon"]`);
  const cartBtns = document.querySelectorAll(`[id^="cart-wishlist"]`);
  const wishlistHandlesElement = document.getElementById("wishlist-handles");
  const wishlistHeaderElement = document.getElementById("wishlist-headers");
  const alertBanner = document.getElementById("alert-banner");
  const removeLinks = document.querySelectorAll(".js-remove-item");

  console.log(wishlist, "path");
  if (window.location.pathname === "/cart") {
    cartBtns.forEach((btn) => {
      let item = btn.getAttribute("data-item");
      item = JSON.parse(item);
      btn.addEventListener("click", (e) => {
        if (!customerData) {
          // Prevent further actions
          showNotAllowedMessage();
        } else {
          if (loadingMessage && wishlistHandlesElement) {
            loadingMessage.style.display = "block";
            wishlistHandlesElement.style.display = "none";
          }
          e.preventDefault();

          const product = {
            product_id: item.product_id,
            product_handle: item.handle,
            proimage: item.image,
            protitle: item.title,
            vname: item.product_title,
            proprice: item.price,
            checked: true,
          };

          // Add item to the cart logic
          addItem(product);

          // Find the remove link associated with this item
          const removeLink = document.querySelector(
            `a[href*='id=${item.key}']`
          );

          // Check if the removeLink is found
          if (removeLink) {
            // removeFromCart(item.key);
            // Simulate the click on the remove link
            if (loadingMessage && wishlistHandlesElement) {
              loadingMessage.style.display = "none";
              wishlistHandlesElement.style.display = "block";
            }

            removeLink.click();
          } else {
            console.error("Remove link not found for item key:", item.key);
          }

          // Optionally, you can remove the item directly using `removeFromCart(item.key)`
          // enableOtherButtons()
        }
      });
    });
  }

  function enableOtherButtons() {
    cartBtns.forEach((btn) => {
      btn.disabled = false; // Ensure buttons are not disabled
      btn.classList.remove("disabled"); // Remove any disabled CSS class if present
    });
  }

  if (!customerDataElement || !productDataElement) {
    console.warn("Required script tags not found");
    return;
  }

  const customerData = JSON.parse(customerDataElement.textContent);

  if (!customerData) {
    handleNotLoggedIn(loadingMessage);
    localStorage.removeItem("build-a-bear__wishlist");
  } else {
    loadZooomyData(customerData.customer_id);
  }
  if (customerData && wishlist.length === 0) {
    emptyWishlist(loadingMessage);
    if (wishlistHeaderElement) {
      wishlistHeaderElement.style.display = "none";
    }
  }

  function emptyWishlist(loadingMessage) {
    if (loadingMessage) {
      loadingMessage.innerHTML = `
      <div class="x-flex x-flex-col logged-in-alert x-justify-center x-items-center page-width">
        <div>
          <p class="sofia-pro-medium x-text-[16px] x-text-black">Your Wishlist is empty</p>
        </div>
        <div class="x-flex x-flex-col x-items-center x-w-full" style="gap: 1rem">
          <a href="/collections/all" class="wishlist-btn-1 x-uppercase sofia-pro-medium x-flex x-justify-center x-items-center x-bg-[#FFD400] x-text-[#0056A2] x-h-[40px] x-px-[10px] x-leading-none">Shop Now</a>
        </div>
      </div>
    `;
    }
    if (wishlistHandlesElement) {
      wishlistHandlesElement.style.display = "none";
      // wishlistHeaderElement.style.display = "none";
    }
    console.warn("Wishlist is empty");
  }

  function removeItem(productId) {
    wishlist = wishlist.filter((item) => item.product_id !== productId);

    const script = document.createElement("script");
    script.src = `https://zooomyapps.com/wishlist/RemoveFromWishlist.php?shop=build-a-bear-za.myshopify.com&productid=${productId}&customerid=${customerData.customer_id}&wishcount=${wishlist.length}`;
    document.head.appendChild(script);

    if (wishlist.length === 0) {
      if (loadingMessage) {
        loadingMessage.style.display = "block";
        emptyWishlist(loadingMessage);
      }
    }

    updateWishlistStorage();
  }

  function addItem(product) {
    console.log(product);
    console.log(customerData);
    wishlist.push(product);
    // updateWishlistStorage();

    const scriptTag = document.createElement("script");
    scriptTag.src = `https://zooomyapps.com/wishlist/wishlist-check1.php?shop=build-a-bear-za.myshopify.com&productid=${
      product.product_id
    }&customerid=${
      customerData.customer_id || "guest"
    }&checked=true&wishcount=${
      wishlist.length
    }&variantname=${new Date()}&totalv=2`;
    document.head.appendChild(scriptTag);
  }

  function updateWishlistStorage() {
    localStorage.setItem("build-a-bear__wishlist", JSON.stringify(wishlist));
    if (window.location.pathname === "/pages/wishlist") {
      fetchProductData();
    }
  }

  function showNotAllowedMessage() {
    // Check if the alert already exists
    const existingAlert = document.getElementById("not-allowed-alert");
    if (existingAlert) return;

    // Create the overlay
    const overlay = document.createElement("div");
    overlay.id = "alert-overlay";
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    overlay.style.zIndex = "9998";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";

    // Create the alert element
    const alertElement = document.createElement("div");
    alertElement.id = "not-allowed-alert";
    alertElement.style.position = "relative";
    alertElement.style.display = "flex";
    alertElement.style.flexDirection = "column";
    alertElement.style.gap = "10px";
    alertElement.style.backgroundColor = "#fff";
    alertElement.style.padding = "20px";
    alertElement.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    // alertElement.style.borderRadius = "8px";
    alertElement.style.textAlign = "center";
    alertElement.style.maxWidth = "90%"; // Adjust for smaller screens
    alertElement.style.width = "500px";
    alertElement.style.height = "200px";
    alertElement.style.justifyContent = "center";
    alertElement.style.zIndex = "9999";
    alertElement.style.transition = "opacity 0.5s ease";
    alertElement.style.opacity = "0"; // Start hidden

    // Add the close (X) button
    const closeButton = document.createElement("span");
    closeButton.innerHTML = "&times;";
    closeButton.style.position = "absolute";
    closeButton.style.top = "10px";
    closeButton.style.right = "10px";
    closeButton.style.cursor = "pointer";
    closeButton.style.fontSize = "20px";
    closeButton.style.fontWeight = "bold";
    closeButton.style.color = "#333";

    // Close the alert when the "X" is clicked
    closeButton.addEventListener("click", closeAlert);

    alertElement.id = "not-allowed-alert";
    alertElement.style.position = "fixed";
    alertElement.style.display = "flex";
    alertElement.style.flexDirection = "column";
    alertElement.style.gap = "10px";
    alertElement.style.top = "50%";
    alertElement.style.left = "50%";
    alertElement.style.transform = "translate(-50%, -50%)";
    alertElement.style.zIndex = "9999";
    alertElement.style.backgroundColor = "#fff";
    alertElement.style.padding = "20px";
    alertElement.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    // alertElement.style.borderRadius = "8px";
    alertElement.style.textAlign = "center";
    alertElement.style.maxWidth = "90%"; // Adjust for smaller screens
    alertElement.style.width = "500px";
    alertElement.style.transition = "opacity 0.3s ease";
    alertElement.style.opacity = "0"; // Start hidden
    alertElement.style.height = "200px";
    alertElement.style.justifyContent = "center";

    // The content inside the alert box
    alertElement.innerHTML = `
      <p>You must be logged in to use the wishlist feature.</p>
      <div class="x-flex x-flex-col x-gap-[10px] x-items-center">
        <a href="/account/login" class="btn btn-1">Login</a>
        <a href="/account/register" class="btn btn-2">Sign up</a>
      </div>
    `;

    // Append the close button to the alert element
    alertElement.appendChild(closeButton);

    // Append the alert element and the overlay to the body
    document.body.appendChild(overlay);
    document.body.appendChild(alertElement);

    // Make the alert visible
    setTimeout(() => {
      alertElement.style.opacity = "1";
    }, 10);

    // Close the alert when clicking outside the box
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        closeAlert();
      }
    });

    // Function to close the alert
    function closeAlert() {
      alertElement.style.opacity = "0";
      setTimeout(() => {
        alertElement.remove();
        overlay.remove();
      }, 500); // Allow time for fade-out effect
    }
  }

  function loadZooomyData(customerId) {
    const ZooomyDataFun = (B, J, M) => {
      B.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: { shop: J, customerid: M },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: (n) => {
          wishlist = extractProductInfo(n);
          updateWishlistStorage();
        },
        error: (t) => console.log(t, "t"),
      });
    };

    if (typeof window.jQuery === "undefined") {
      loadJQuery(() =>
        ZooomyDataFun(
          window.jQuery.noConflict(true),
          "build-a-bear-za.myshopify.com",
          customerId
        )
      );
    } else {
      ZooomyDataFun(window.jQuery, "build-a-bear-za.myshopify.com", customerId);
    }
  }

  function loadJQuery(callback) {
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js";
    script.type = "text/javascript";
    script.onload = callback;
    document.head.appendChild(script);
  }

  function extractProductInfo(obj) {
    return Array.from({ length: obj.records }).map((_, i) => ({
      product_id: obj.product_id[i],
      product_handle: obj.product_handle[i],
      proimage: obj.product_img[i],
      protitle: obj.product_name[i],
      vname: obj.variant_name[i],
      proprice: obj.product_price[i],
      checked: true,
    }));
  }

  function fetchProductData() {
    console.log(wishlist, 'wishlist')
    const productHandles = wishlist.map((item) => item.product_handle);
    let fetchedProductsCount = 0;

    // Clear the previous wishlist before rendering the new one
    if (wishlistHandlesElement) {
      wishlistHandlesElement.innerHTML = "";
    }

    productHandles.forEach((handle) => {
      console.log(handle, 'handle')
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const priceHTML = `R ${(product.price / 100).toFixed(2)}`;

          if (wishlistHandlesElement) {
            wishlistHandlesElement.innerHTML += `
          <div data-handle="${product.handle}" class="x-flex md:x-flex-row x-flex-col x-justify-between md:x-gap-[20px] x-gap-[30px] x-p-[20px] x-bg-[#F7F7F7]">
            <div class="x-flex x-flex-row x-items-center x-gap-[40px]">
              <a href="/products/${product.handle}">
                <img width="300" height="300" src="${product.images[0]}" class="x-mix-blend-multiply wishlist__product-image"/>
              </a>
              <div class="x-flex x-flex-col x-gap-[20px]">
                <a href="/products/${product.handle}">
                  <p class="sofia-pro-bold md:x-text-[18px] x-text-[14px] x-leading-[120%]">${product.title}</p>
                </a>
                <div>
                  <p class="sofia-pro-regular md:x-text-[18px] x-text-[14px] x-leading-none">${priceHTML}</p>
                </div>
              </div>
            </div>
            <div class="x-flex x-flex-col x-justify-between x-items-end">
              <button class="remove-btn max-md:x-hidden" data-id="${product.id}">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M2.08067 19.3707C2.38695 19.2637 2.67134 19.1011 2.91945 18.8909C3.05432 18.7745 3.18952 18.6583 3.32508 18.5422C3.95001 18.0061 4.59462 17.4531 5.18777 16.8599C5.23362 16.8141 5.27957 16.7682 5.32459 16.7215C6.43197 15.5863 7.54575 14.4208 8.62289 13.2936C10.0521 11.7983 11.5299 10.252 13.0099 8.75834C15.1285 6.62035 17.026 4.24186 18.8612 1.94153L18.9201 1.86783C19.0257 1.7128 19.1018 1.53984 19.1445 1.35768C19.1805 1.24304 19.2214 1.11332 19.2783 0.960565C19.2886 0.933313 19.2909 0.903835 19.285 0.875523C19.2791 0.847211 19.2653 0.821297 19.2451 0.800717C19.2251 0.78003 19.1994 0.765629 19.1713 0.759094C19.1431 0.752666 19.1136 0.754276 19.0861 0.763879C18.9258 0.819552 18.7847 0.860171 18.6597 0.895532C18.4503 0.937658 18.2509 1.02074 18.0728 1.14023L17.6182 1.49816C16.7348 2.19322 15.8208 2.91151 14.9799 3.6858C10.4493 7.85728 6.19978 12.444 2.09044 16.8796L1.35287 17.6756C1.24142 17.7961 1.14238 17.9274 1.0573 18.0677C0.952422 18.2205 0.898693 18.4023 0.903903 18.5865C0.909112 18.7707 0.972969 18.9478 1.08624 19.0919C1.19666 19.2421 1.35412 19.3508 1.534 19.4013C1.71389 19.4517 1.90612 19.441 2.08067 19.3707Z" fill="#0056A2"/>
                  <path d="M2.08067 0.69616C2.38695 0.803179 2.67134 0.965832 2.91945 1.17596C3.05432 1.2924 3.18952 1.40862 3.32508 1.52465C3.95001 2.06083 4.59462 2.61381 5.18777 3.20696C5.23362 3.25281 5.27957 3.29872 5.32459 3.34541C6.43197 4.48063 7.54575 5.64613 8.62289 6.77329C10.0521 8.26861 11.5299 9.81494 13.0099 11.3086C15.1285 13.4465 17.026 15.825 18.8612 18.1254L18.9201 18.1991C19.0257 18.3541 19.1018 18.5271 19.1445 18.7092C19.1805 18.8239 19.2214 18.9536 19.2783 19.1063C19.2886 19.1336 19.2909 19.1631 19.285 19.1914C19.2791 19.2197 19.2653 19.2456 19.2451 19.2662C19.2251 19.2869 19.1994 19.3013 19.1713 19.3078C19.1431 19.3142 19.1136 19.3126 19.0861 19.303C18.9258 19.2473 18.7847 19.2067 18.6597 19.1714C18.4503 19.1292 18.2509 19.0462 18.0728 18.9267L17.6182 18.5687C16.7348 17.8737 15.8208 17.1554 14.9799 16.3811C10.4493 12.2096 6.19978 7.62291 2.09044 3.18726L1.35287 2.39128C1.24142 2.27081 1.14238 2.13945 1.0573 1.99923C0.952422 1.84638 0.898693 1.66464 0.903903 1.48042C0.909112 1.29619 0.972969 1.11908 1.08624 0.974946C1.19666 0.824826 1.35412 0.716083 1.534 0.665643C1.71389 0.615204 1.90612 0.625944 2.08067 0.69616Z" fill="#0056A2"/>
                </svg>
              </button>
              <button class="add-to-cart-btn x-uppercase sofia-pro-medium x-flex x-justify-center x-items-center x-bg-[#FFD400] x-text-[#0056A2] x-h-[40px] x-px-[10px] x-leading-none" js-quick-add data-handle="${product.handle}" data-id="${product.id}" data-variant-id="${product.variants[0].id}">Add to Cart</button>
            </div>
          </div>
        `;

            fetchedProductsCount++;

            if (fetchedProductsCount === wishlist.length) {
              loadingMessage.style.display = "none";
              wishlistHandlesElement.style.display = "flex";
            }

            const addToCartButtons =
              document.querySelectorAll(".add-to-cart-btn");
            addToCartButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                const productVariantId = this.getAttribute("data-variant-id");
                // Trigger the quick-add functionality using Liquid AJAX API
                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: productVariantId,
                    quantity: 1,
                  }),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    alertBanner.classList.remove("x-hidden");
                    alertBanner.classList.add("x-flex");

                    alertBanner.innerHTML = `Product has been successfully added to cart!`;

                    // removeItem(productVariantId)
                    // Remove item from wishlist
                    // const removeButton = document.querySelector(
                    //   `.remove-btn[data-id="${productId}"]`
                    // );

                    // console.log(removeButton, "btn");
                    // if (removeButton) {
                    //   removeButton.click();
                    // }

                    // Hide the alert banner after 3 seconds
                    setTimeout(() => {
                      alertBanner.classList.add("x-hidden");
                    }, 3000);

                    removeItem(productId);
                    // Optionally refresh or update the cart UI
                  })
                  .catch((error) => {
                    console.error("Error adding product to cart:", error);
                  });
              });
            });

            const removeButtons = document.querySelectorAll(".remove-btn");
            removeButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                alertBanner.classList.remove("x-hidden");
                    alertBanner.classList.add("x-flex");

                    alertBanner.innerHTML = `Product has been successfully removed from wishlist!`;

                    setTimeout(() => {
                      alertBanner.classList.add("x-hidden");
                    }, 3000);

                removeItem(productId, product);
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    });
  }

  function removeFromCart(lineItemId) {
    console.log(lineItemId);
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity: 0, // Set quantity to 0 to remove the item
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        const alertBanner = document.getElementById("alert-banner");
        alertBanner.classList.remove("x-hidden");
        alertBanner.classList.add("x-flex");
        alertBanner.innerHTML = `
        Item has been removed from the cart.
      `;

        // Hide the alert after 3 seconds
        setTimeout(() => {
          alertBanner.classList.add("x-hidden");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error removing item from cart:", error);
      });
  }

  function handleNotLoggedIn(loadingMessage) {
    window.localStorage.removeItem("build-a-bear__wishlist");

    if (loadingMessage) {
      loadingMessage.innerHTML = `
        <div class="x-flex x-flex-col logged-in-alert x-justify-center x-items-center page-width">
          <div style="max-width: 400px">
            <p class="sofia-pro-regular x-text-[14px]">You need an account to use our wishlist function. Create an account now and never lose track of your favourite items.</p>
          </div>
          <div class="x-flex x-flex-col x-items-center x-w-full" style="gap: 1rem">
            <a href="/account/login" class="wishlist-btn-1 x-uppercase sofia-pro-medium x-flex x-justify-center x-items-center x-bg-[#FFD400] x-text-[#0056A2] x-h-[40px] x-px-[10px] x-leading-none">Login</a>
            <a href="/account/register" class="wishlist-btn-2 x-uppercase sofia-pro-medium x-flex x-justify-center x-items-center x-bg-[#0056A2] x-text-[#FFD400] x-h-[40px] x-px-[10px] x-leading-none">Sign up</a>
          </div>
        </div>
      `;
    }

    if (wishlistHandlesElement) {
      wishlistHandlesElement.style.display = "none";
      wishlistHeaderElement.style.display = "none";
    }

    console.warn("Wishlist requires a logged-in customer");
  }
});
